(function () {
  /** @type HTMLElement */
  const form = document.querySelector("#age-verification");
  const productForm = document.querySelector("product-form");
  /** @type {HTMLInputElement} */
  const inputEl = form.querySelector("#date-of-birth");
  /** @type HTMLDialogElement */
  const notAllowedDialogEl = document.querySelector(
    ".age-restriction-not-allowed"
  );
  const ageRestrictionDialogEl = document.querySelector(
    ".age-restriction-form"
  );
  const localStorageAge = localStorage.getItem("customerOver18");
  if (localStorageAge) {
    const isOver18 = JSON.parse(localStorageAge);
    if (isOver18) return;
    notAllowedDialogEl.showModal();
    return productForm.remove();
  }

  ageRestrictionDialogEl.showModal();

  form.addEventListener("submit", (e) => handleFormSubmit(e, form));

  const handleFormSubmit = (e, form) => {
    e.preventDefault();
    const formData = new FormData(form);
    const dateOfBirth = formData.get("date-of-birth");
    const isOver18 = checkOver18(dateOfBirth);
    localStorage.setItem("customerOver18", JSON.stringify(isOver18));
    if (isOver18) return ageRestrictionDialogEl.remove();
    ageRestrictionDialogEl.remove();
    notAllowedDialogEl.showModal();
    return productForm.remove();
  };

  /*
   * @param {string} dateOfBirth
   */
  const checkOver18 = (dateOfBirth) => {
    const monthDifference =
      new Date().getMonth() - new Date(dateOfBirth).getMonth();
    let age = new Date().getFullYear() - new Date(dateOfBirth).getFullYear();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 &&
        new Date().getDate() < new Date(dateOfBirth).getDate())
    ) {
      age = age - 1;
    }

    if (age < 18) return false;

    return true;
  };

  inputEl.addEventListener("input", (e) => handleInputEvent(e));

  const handleInputEvent = (e) => {
    let inputValue = inputEl.value.replace(/\D/g, "");

    if (inputValue.length > 2) {
      inputValue = inputValue.substring(0, 2) + "/" + inputValue.substring(2);
    }
    if (inputValue.length > 5) {
      inputValue =
        inputValue.substring(0, 5) + "/" + inputValue.substring(5, 9);
    }

    inputEl.value = inputValue;
  };
})();
